import { LOAD_REVIEWS, SELECT_REVIEW, CLEAN_SELECTED_REVIEW } from "../actions/actionTypes";

const initialState = {
    reviews: [],
    selectedReview: null
};

export const reviewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_REVIEWS:
            return {
                ...state,
                reviews: action.reviews
            };
        case SELECT_REVIEW:
            return {
                ...state,
                selectedReview: action.review
            };
        case CLEAN_SELECTED_REVIEW:
            return {
                ...state,
                selectedReview: null
            };
        default:
            return state;
    }
};